import i18next from 'i18next';
import ja from './locales/ja.json'

i18next
.init({
    interpolation: {
        escapeValue: false,
    },
    lng: 'ja', // ' ja' | 'en'

    resources: {
        ja
    },
})

export default i18next